import { createSlice } from "@reduxjs/toolkit";

export const alertaSlice = createSlice({
  name: "alerta",
  initialState: {
    path: "",
    state: {},
  },
  reducers: {
    toggle: (state, action) => {
      typeof action.payload === "string"
        ? (state.path = action.payload)
        : (state.path = action.payload.path);

      typeof action.payload === "string"
        ? (state.state = {})
        : (state.state = action.payload.state)
    },
  },
});

export const { toggle } = alertaSlice.actions;

export default alertaSlice.reducer;
